import { useEffect, useState } from "react";
import { updateCoponsForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DropDown from "../../components/GDropDownList/DropDown";
import { ThreeDot } from "react-loading-indicators";

export default function EditCoponsUi({statusOfCopons, coponsData}) {

    const nav = useNavigate();
    const {coponId} = useParams();
    const [isActive, setIsActive] = useState(coponsData?.is_active === true ? "1" : "0");
    const [coponTypeId, setCoponsTypeId] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;    

    useEffect(() => {
        setIsActive(coponsData.is_active === true ? "1" : "0");
        setCoponsTypeId(coponsData.discount_type);
    },[coponsData]);

    const onchange = (e) => {
        setCoponsTypeId(e);
    };  

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
            formData.append("is_active", isActive ? "1" : "0");
        const result = await updateCoponsForm(coponId, formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    if (Object.entries(coponsData).length < 1) {
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "coupon name" : "اسم الكوبون"} </label>
                    <input
                        type="text"
                        defaultValue={coponsData.code}
                        name="code"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter coupon name" : "ادخل اسم الكوبون"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "coupon description" : "وصف الكوبون "} </label>
                    <input
                        type="text"
                        defaultValue={coponsData.description}
                        name="description"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter coupon description" : "أدخل وصف الكوبون "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "discount value" : "قيمة الخصم"} </label>
                    <input
                        type="number"
                        defaultValue={coponsData.value}
                        name="value"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter discount value" : "ادخل قيمة الخصم"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "discount type" : "شكل الخصم"}</label>
                    <DropDown options={statusOfCopons} value={coponTypeId} onchange={(e)=> onchange(e, "discount_type")} defaultText={currentLang === "en" ? "Select discount type" : "أختر شكل الإعلان "} paramkey="discount_type" />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "usage limit" : "عدد مستخدمين الكوبون"} </label>
                    <input
                        type="number"
                        defaultValue={coponsData.usage_limit}
                        name="usage_limit"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter usage limit" : "ادخل عدد مسخدمين الكوبون"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "min order to use coupon" : "الوصف باللغة الانجليزية "} </label>
                    <input
                        type="number"
                        defaultValue={coponsData.min_order_value}
                        name="min_order_value"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter the min order to use coupon" : "قيمة أقل طلب لاستخدام الكوبون"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "start date" : "وقت البدء"} </label>
                    <input
                        type="date"
                        defaultValue={coponsData.start_at}
                        name="start_at"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter start date" : "أدخل وقت البدء "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "end date" : "وقت الانتهاء"} </label>
                    <input
                        type="date"
                        defaultValue={coponsData.end_at}
                        name="end_at"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter end date" : "أدخل وقت الانتهاء "}
                    />
                </div>
                <div className="mb-4 ">
                    <label className="block text-white mb-4">
                        {currentLang === "en" ? "Active Status" : "حالة التفعيل"}
                    </label>
                    <div className="flex items-center gap-3">
                        <div
                            onClick={() => setIsActive(!isActive)}
                            className={`relative w-14 h-7 rounded-full cursor-pointer transition
                            ${isActive ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
                        >
                            <span
                            className={`w-5 h-5 mt-1 bg-white rounded-full shadow-md block
                                transform transition
                                ${isActive ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                            />
                        </div>
                        <span className="text-white text-sm">
                        {isActive
                            ? currentLang === "en"
                            ? "Active"
                            : "مفعل"
                            : currentLang === "en"
                            ? "Inactive"
                            : "غير مفعل"}
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex justify-center w-full my-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};